import { Component } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { Tax } from '../../taxes/_types/tax';
import { WorkerSeizuresService } from '../_services/workers-seizures.service';
import { FilesService } from '../../common/_services/files.service';
import { WorkerSeizure } from '../_types/worker-seizure';
import { File } from 'src/app/modules/common/_types/file';
import { LoginService } from '../../login/login.service';
import { WorkerSeizuresAmmountsService } from '../_services/workers-seizures-ammounts.service';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { WorkersSeizureAmmountComponent } from './workers-seizure-ammount/workers-seizure-ammount.component';

@Component({
    selector: 'app-workers-seizure',
    templateUrl: './workers-seizure.component.html',
    styleUrls: ['./workers-seizure.component.scss'],
    standalone: false
})
export class WorkersSeizureComponent {

  public workerSeizureFormGroup!: RxFormGroup;
  public workerSeizure: WorkerSeizure = new WorkerSeizure();  
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  public total: number = 0;
  public subtotal: number = 0;
  public taxAmount: number = 0;
  public taxes: Tax[] = [];
  public loadingTaxes: boolean = false;
  public files: any[] = [];
  public closeFiles: any[] = [];
  public business: any[] = [];
  public workersSeizureAmmounts: any[] = [];
  public totalWorkersSeizureAmmountsRecords: number = 0;

  public status: any[] = [
    { name: 'Cerrado', value: true },
    { name: 'Abierto', value: false }
  ];
  public workersSeizureAmmountsTotal: number = 0;
  public workersSeizureAmmountsTotalRest: number = 0;
  private lastGridEvent: any;

  constructor(
    private workerSeizuresService: WorkerSeizuresService,
    private workersSeizuresAmmountsService: WorkerSeizuresAmmountsService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private filesService: FilesService,
    private loginService: LoginService,
    private dialogService: DialogService
  ) {
    this.workerSeizureFormGroup = this.formBuilder.formGroup<WorkerSeizure>(this.workerSeizure) as RxFormGroup;
  }

  async ngOnInit(){
    
    if (this.config.data.workerSeizureId) {
      this.loadworkerSeizure(this.config.data.workerSeizureId);
    } else {
      this.workerSeizure.workerId = this.config.data.workerId;     
    }
    this.allowWrite = this.loginService.hasPermission("WORKERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("WORKERS.DELETE");
  }

  async loadworkerSeizure(id: string) {
    this.workerSeizure = await firstValueFrom(this.workerSeizuresService.get(id, {include: ["caseFile,closedCaseFile"]}));
    this.workerSeizureFormGroup.patchValue(this.workerSeizure);
    this.loadWorkerSeizureAmmounts({first: 0, rows: 25});
  }

  async loadWorkerSeizureAmmounts($event: any) {
      this.lastGridEvent = $event;
    let filters = {
      workerSeizureId: new Filter(FilterOperation.equals, 'workerSeizureId', '', this.workerSeizure.id)
    };
    let params: IParamsCollection = {
        page: { number: $event.first + 1, size: $event.rows },
      filter: FilterBuilder.fromObject(filters).build()
    };
    var response = await firstValueFrom(this.workersSeizuresAmmountsService.all(params));
    this.workersSeizureAmmounts = response.data;
    this.workersSeizureAmmountsTotal = await firstValueFrom(this.workersSeizuresAmmountsService.workerSeizureTotalAmmount(this.workerSeizure.id as string));
    this.workersSeizureAmmountsTotalRest = (this.workerSeizure && this.workerSeizure.ammount ? this.workerSeizure.ammount : 0) - this.workersSeizureAmmountsTotal;
  }


  async save() {    
    let valid = this.formValidationService.validateForm(this.workerSeizureFormGroup);    
    if (valid) {
      if(!this.workerSeizureFormGroup.value.isClosed)
      {
        this.workerSeizureFormGroup.value.closedDate = null;
        this.workerSeizureFormGroup.value.closedCaseFileId = null;
      }

      this.workerSeizure = Object.assign(this.workerSeizure, this.workerSeizureFormGroup.value);

     
      let workerSeizure = await firstValueFrom(this.workerSeizuresService.save(this.workerSeizure));    
      await this.saveFiles(workerSeizure); // Guardar los ficheros asociados al embargo
      this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Embargo asignado correctamente' });
      this.dynamicDialogRef.close();
      
      this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Embargo asignado correctamente' });
      this.dynamicDialogRef.close();
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }

  async saveFiles(workerSeizure: any){
    if (this.files.length > 0) {
      try {
        for (let file of this.files) {
          let data: File = new File();
          data.fileName = file.name;
          data.size = file.size;
          data.contentType = file.type; 
          //creamos el file
          let fileResponse = await firstValueFrom(this.filesService.save(data));  
          //subimos el fichero al file
          let response = await firstValueFrom(this.filesService.upload(fileResponse.id as string, file));  
          //guardamos el file en el expediente
          workerSeizure.caseFileId = fileResponse.id as string;
          await firstValueFrom(this.workerSeizuresService.save(workerSeizure));
        }
      } catch (error) {
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Error al guardar el fichero." });
      }
    }
    if (this.closeFiles.length > 0) {
      try {
        for (let file of this.closeFiles) {
          let data: File = new File();
          data.fileName = file.name;
          data.size = file.size;
          data.contentType = file.type; 
          //creamos el file
          let fileResponse = await firstValueFrom(this.filesService.save(data));  
          //subimos el fichero al file
          let response = await firstValueFrom(this.filesService.upload(fileResponse.id as string, file));  
          //guardamos el file en el expediente
          workerSeizure.closedCaseFileId = fileResponse.id as string;
          await firstValueFrom(this.workerSeizuresService.save(workerSeizure));
        }
      } catch (error) {
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Error al guardar el justificante de pago." });
      }
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el embargo?",
      header: "Eliminar embargo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerSeizuresService.delete(this.workerSeizure.id).subscribe({
          next: () => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Embargo eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }
  
  async onFileSelect(event: any, caseFile: boolean = true) {
    let files = event.files;
    for (let file of files) {
      if(caseFile){
        this.files.push(file);
        if(this.workerSeizure.caseFile != null) this.workerSeizure.caseFile.fileName = "";
      }else{
        this.closeFiles.push(file);
        if(this.workerSeizure.closedCaseFile != null) this.workerSeizure.closedCaseFile.fileName = "";
      }
    }
  }
  
  downloadFile(fileId?: string) {
    if(fileId != null && fileId!=""){
      this.filesService.download(fileId);
    }
  }


  editWorkersSeizureAmmounts(id: any){
   const ref = this.dialogService.open(WorkersSeizureAmmountComponent, {
      closable: true,
      modal: true,
      data: {
        workerSeizureId: this.workerSeizure.id,
        id: id ? id : null,
      },
      header: id ? "Embargo" : "Nuevo Embargo",
      width: '30%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadWorkerSeizureAmmounts(this.lastGridEvent);
    });
  }

  deleteWorkersSeizureAmmounts(ammount: any){

  }
}
